// src/components/ConfirmationPopup.jsx
import React from 'react';

const ConfirmationPopup = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  actionType, 
  amount, 
  loading 
}) => {
  if (!isOpen) return null;

  // Map action types to appropriate colors
  const actionColors = {
    deposit: 'green',
    withdraw: 'red',
    mint: 'green',
    redeem: 'red',
    burn: 'red'
  };

  const color = actionColors[actionType] || 'blue';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
        {/* Close button */}
        <button 
          onClick={onClose}
          disabled={loading}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        {/* Title */}
        <h2 className="text-xl font-bold text-gray-800 mb-4">{title}</h2>
        
        {/* Content */}
        <div className="mb-6">
          <p className="text-gray-600 mb-4">{message}</p>
          
          {/* Transaction details */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="flex justify-between mb-2">
              <span className="font-medium">Action:</span>
              <span className={`font-medium text-${color}-600`}>{actionType.charAt(0).toUpperCase() + actionType.slice(1)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Amount:</span>
              <span className="font-mono">{amount} ETH</span>
            </div>
          </div>
        </div>
        
        {/* Actions */}
        <div className="flex space-x-3 justify-end">
          <button
            onClick={onClose}
            disabled={loading}
            className={`
              px-4 py-2 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300
              focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 transition
              ${loading ? 'opacity-50 cursor-not-allowed' : ''}
            `}
          >
            Cancel
          </button>
          
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`
              px-4 py-2 bg-${color}-500 text-white rounded-lg font-medium hover:bg-${color}-600
              focus:outline-none focus:ring-2 focus:ring-${color}-500 focus:ring-opacity-50 transition
              ${loading ? 'opacity-50 cursor-not-allowed' : ''}
            `}
          >
            {loading ? (
              <div className="flex items-center">
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Processing...
              </div>
            ) : (
              `Confirm ${actionType.charAt(0).toUpperCase() + actionType.slice(1)}`
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;